import { render, staticRenderFns } from "./handling_resignation.vue?vue&type=template&id=05389a33&"
import script from "./handling_resignation.vue?vue&type=script&lang=js&"
export * from "./handling_resignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports